import {
  Component,
  ElementRef,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';

@Component({
  standalone: false,
  selector: 'ti-field-eye',
  templateUrl: './field-eye.component.html',
  styleUrls: ['./field-eye.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FieldEyeComponent implements OnInit {
  @Input() set mask(value: boolean) {
    this.toggleAsterisks(value);
  }
  @Input() hideMask = false;
  @Input() outerManage = false; // TODO: get rid
  @Output() onMasked = new EventEmitter<boolean>();

  strings = tiStrings.app.misc;
  isMasked = true;
  title: string;
  inputRef: HTMLInputElement;

  constructor(
    private elRef: ElementRef,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this.inputRef = this.elRef.nativeElement.querySelector('input');
    this.toggleAsterisks(this.isMasked);
  }

  toggleAsterisks(mask: boolean = null) {
    if (this.outerManage && mask === null) {
      this.onMasked.emit(this.isMasked);
    } else if (mask === null) {
      this.isMasked = !this.isMasked;
      this.onMasked.emit(this.isMasked);
      this.inputRef.type = this.isMasked ? 'password' : 'text';
      this.inputRef.focus();
    } else {
      this.isMasked = mask;
      this.inputRef.type = this.isMasked ? 'password' : 'text';
      this.cdr.detectChanges();
    }
  }
}
